import {makeAutoObservable} from "mobx";
let moment = require('moment');

class Store {
  default_days_behind = 7
  min_day_limit = 600;
  end_date = moment().format('YYYY-MM-DD');
  day_before_end_date = moment(this.end_date).format('YYYY-MM-DD');
  // day_before_end_date = moment(this.end_date).subtract(1, 'days').format('YYYY-MM-DD');
  start_date = moment().subtract(this.default_days_behind, 'days').format('YYYY-MM-DD');

  modified_start_date = '';
  modified_end_date = '';

  entities_graph_data = [];
  increased_revenue_data = [];
  revenue_segments_data = [];
  all_time_revenue_segments_data = [];
  last_hours_events = [];
  fp_overlaps = [];
  checks = [];
  twik_control_segments = {}
  wins_count_control_and_twik = []
  wins_count_twik_no_cache = []
  wins_count_control_and_twik_no_cache = []
  wins_count_twik = []
  fp_survivability = {with_ts: [], no_ts: []}
  
  
  //// New
  events = []
  checkouts = []
  rps = []
  setEvents(events) {
    this.events = events;
  }
  setCheckouts(checkouts) {
    this.checkouts = checkouts;
  }
  setRps(rps) {
    this.rps = rps;
  }
  /////////////////////

  constructor() {
    makeAutoObservable(this)
  }

  setModifiedStartAndEndDate(start_date, end_date) {
    this.modified_start_date = start_date;
    this.modified_end_date = end_date;
  }

  setWinsControlAndTwikDealsGraphData(wins) {
    this.wins_count_control_and_twik = wins;
  }

  setWinsControlAndTwikNoCacheDealsGraphData(wins) {
    this.wins_count_control_and_twik_no_cache = wins;
  }

  setWinsTwikNoCacheDealsGraphData(wins) {
    this.wins_count_twik_no_cache = wins;
  }

  setFpSurvivability(data) {
    this.fp_survivability = data;
  }

  setWinsOnlyTwikDealsGraphData(wins) {
    this.wins_count_twik = wins;
  }

  setEntitiesGraphData(entities) {
    this.entities_graph_data = entities;
  }

  setTwikControlData(entities) {
    this.twik_control_segments = entities;
  }

  setFpOverlapsGraphData(entities) {
    this.fp_overlaps = entities;
  }

  setIncreasedRevenueGraphData(entities) {
    this.increased_revenue_data = entities;
  }

  setRevenueSegmentsGraphData(entities) {
    this.revenue_segments_data = entities;
  }

  setAllTimeRevenueSegmentsGraphData(entities) {
    this.all_time_revenue_segments_data = entities;
  }

  setLastHoursEvents(last_hours_events) {
    this.last_hours_events = last_hours_events;
  }

  setChecks(checks) {
    this.checks = checks;
  }

  addChecks(checks) {
    this.checks.push(...checks);
  }

}

const store = new Store();

export default store;
